<script>
	import Icon from './lib/Icon.svelte';
	let { onGoToLogin } = $props();

	let mounted = $state(false);
	$effect(() => {
		mounted = true;
	});

	// === Stock images via Unsplash CDN (stable photo IDs) ===
	// Replace these with your own Cloudinary / S3 URLs in production.
	const IMG = {
		heroPerson:    'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=900&q=80',
		teamCallcenter:'https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=900&q=80',
		costaRica:     'https://images.unsplash.com/photo-1518533954129-7774297db60a?auto=format&fit=crop&w=1200&q=80',
		// Industry photos
		turismo:       'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=600&q=70',
		restaurante:  'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=600&q=70',
		realEstate:   'https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=600&q=70',
		retail:       'https://images.unsplash.com/photo-1472851294608-062f824d29cc?auto=format&fit=crop&w=600&q=70',
		servicios:    'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=600&q=70',
		educacion:    'https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=600&q=70',
		// Testimonial avatars
		avatar1:      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=facearea&w=120&h=120&q=80&facepad=2',
		avatar2:      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=facearea&w=120&h=120&q=80&facepad=2',
		avatar3:      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=facearea&w=120&h=120&q=80&facepad=2'
	};

	const INDUSTRIES = [
		{ key: 'turismo',     icon: '🏝️', title: 'Turismo y Tours',           img: IMG.turismo,
		  desc: 'Reserva, confirma y atiende huéspedes en español e inglés. Recordatorios automáticos antes del check-in.' },
		{ key: 'restaurantes',icon: '🍽️', title: 'Restaurantes y Sodas',      img: IMG.restaurante,
		  desc: 'Pedidos por WhatsApp, menú interactivo y reservas. Tu mesera digital 24/7 sin saturarte.' },
		{ key: 'realestate',  icon: '🏠', title: 'Bienes Raíces',              img: IMG.realEstate,
		  desc: 'Califica leads automáticamente: presupuesto, zona y plazo. Solo recibes los prospectos que valen la pena.' },
		{ key: 'retail',      icon: '🛍️', title: 'Comercio y Tiendas',         img: IMG.retail,
		  desc: 'Catálogo siempre disponible, seguimiento de pedidos y carrito recuperado por WhatsApp.' },
		{ key: 'servicios',   icon: '🔧', title: 'Servicios Profesionales',    img: IMG.servicios,
		  desc: 'Cotiza, agenda citas y cobra el anticipo. Tu agente IA pre-califica antes de que veas el chat.' },
		{ key: 'educacion',   icon: '🎓', title: 'Educación y Cursos',         img: IMG.educacion,
		  desc: 'Inscripciones, recordatorios de clase y soporte a estudiantes. Reduce el "no-show" con seguimiento automático.' }
	];

	const FEATURES = [
		{ icon: 'sparkles',     color: '#25d366',
		  title: 'AI Agents que actúan',
		  desc: 'No solo responden — califican leads, crean oportunidades, escalan a humanos cuando hace falta. Aprenden de cada conversación.' },
		{ icon: 'kanban',       color: '#4f6df5',
		  title: 'Pipeline visual',
		  desc: 'Mueve leads por etapas con drag & drop. Timeline completo: notas, llamadas, cambios de etapa, todo a un click.' },
		{ icon: 'inbox',        color: '#0ea5e9',
		  title: 'Bandeja unificada',
		  desc: 'WhatsApp, web, email y más en un solo lugar. Asignación automática, transferencias y notas internas con @menciones.' },
		{ icon: 'zap',          color: '#f59e0b',
		  title: 'Salesbot visual',
		  desc: 'Construye flujos sin código: pregunta, condiciona, etiqueta, llama un AI Agent o escala. Drag, drop, listo.' },
		{ icon: 'book-open',    color: '#a855f7',
		  title: 'Base de conocimiento',
		  desc: 'Sube tus FAQs, políticas y manuales. Los AI Agents responden con datos verificados, no inventan.' },
		{ icon: 'trending-up',  color: '#ef4444',
		  title: 'Analítica que importa',
		  desc: 'Tiempo de respuesta, conversión, embudo, satisfacción de IA. Ve qué funciona y qué optimizar.' }
	];

	const STEPS = [
		{ n: '01', title: 'Conecta tus canales',     desc: 'Vincula WhatsApp Business, instala el widget en tu sitio o conéctate por API. Listo en minutos.' },
		{ n: '02', title: 'Configura tu agente IA',  desc: 'Elige una plantilla (Vendedor, Soporte, Calificador), ajusta tono y carga tu base de conocimiento.' },
		{ n: '03', title: 'Atiende y vende mejor',   desc: 'Tu equipo solo ve los chats que importan. La IA filtra, califica y agenda. Tú cierras.' }
	];

	const TESTIMONIALS = [
		{ name: 'Andrés Vargas', role: 'Director Comercial · TourCR',
		  avatar: IMG.avatar2,
		  quote: 'Pasamos de tardar 6 horas en responder a 2 minutos. La IA pre-califica reservas en inglés y español, mi equipo solo cierra. Pura vida.' },
		{ name: 'María Quesada', role: 'Dueña · Soda La Esquina',
		  avatar: IMG.avatar1,
		  quote: 'Antes los pedidos por WhatsApp eran un caos. Ahora el bot toma la orden, confirma y avisa a cocina. Vendí 30% más este trimestre.' },
		{ name: 'José Brenes',   role: 'CEO · Inmobiliaria Costa Verde',
		  avatar: IMG.avatar3,
		  quote: 'Calificamos prospectos automáticamente con la IA: zona, presupuesto, plazo. Mi equipo de 4 vende como uno de 12. Vale cada colón.' }
	];

	const STATS = [
		{ value: '< 30s',  label: 'Tiempo medio de primera respuesta' },
		{ value: '+80%',   label: 'Reducción de tickets repetitivos' },
		{ value: '24/7',   label: 'Cobertura sin contratar de noche' },
		{ value: '🇨🇷',     label: 'Hecho desde Costa Rica' }
	];

	// Precios en colones primero; el equivalente en USD usa TC ₡460.
	const PLANS = [
		{ name: 'Inicio', priceCrc: '₡14.850', priceUsd: '$30', period: '/mes',
		  bullets: ['1 canal (WhatsApp o Web)', 'Flujos visuales incluidos', 'IA lista: conecta tu propia API o recarga créditos desde ₡5.000', '500 conversaciones/mes', 'Hasta 2 agentes humanos'],
		  cta: 'Probar 14 días gratis' },
		{ name: 'Profesional', priceCrc: '₡23.000', priceUsd: '$50', period: '/mes',
		  highlighted: true,
		  bullets: ['Canales ilimitados', '5 AI Agents con tools', '5.000 conversaciones/mes', 'Hasta 10 agentes humanos', 'Pipeline + flujos visuales', 'Embeddings y RAG'],
		  cta: 'Comenzar ahora' },
		{ name: 'Empresa', priceCrc: 'A medida', priceUsd: '', period: '',
		  bullets: ['Todo lo del plan Pro', 'Conversaciones ilimitadas', 'Multi-organización', 'SLA y soporte dedicado', 'Onboarding asistido', 'Hosting en CR (opcional)'],
		  cta: 'Contactar ventas' }
	];
</script>

<div class="lp" class:mounted>
	<!-- ====================== Header ====================== -->
	<header class="lp-head">
		<div class="container nav">
			<div class="brand">
				<div class="brand-mark">M</div>
				<span class="brand-name">Mangu</span>
				<span class="cr-flag" title="Hecho en Costa Rica">🇨🇷</span>
			</div>
			<nav class="links">
				<a href="#features">Funciones</a>
				<a href="#industries">Industrias</a>
				<a href="#how">Cómo funciona</a>
				<a href="#pricing">Precios</a>
			</nav>
			<div class="actions">
				<button class="btn btn-ghost btn-sm" onclick={onGoToLogin}>Iniciar sesión</button>
				<button class="btn btn-primary btn-sm" onclick={onGoToLogin}>
					Empezar gratis <Icon name="arrow-right" size={14} />
				</button>
			</div>
		</div>
	</header>

	<!-- ====================== Hero ====================== -->
	<section class="hero">
		<div class="container hero-grid">
			<div class="hero-text">
				<div class="badge-pill">
					<span class="dot pulse"></span>
					AI Agents · CRM · Made in Costa Rica
				</div>
				<h1>
					Convierte cada chat en
					<span class="hl">una venta</span>,
					sin sumar gente.
				</h1>
				<p class="lead">
					Mangu es la primera plataforma costarricense que une <b>CRM, WhatsApp,
					web chat y agentes IA</b> que de verdad <i>actúan</i>: califican leads,
					crean oportunidades y escalan al humano correcto en el momento justo.
				</p>
				<div class="cta-row">
					<button class="btn btn-primary btn-lg" onclick={onGoToLogin}>
						Empezar gratis
						<Icon name="arrow-right" size={16} />
					</button>
					<a class="btn btn-secondary btn-lg" href="https://wa.me/50686789960" target="_blank" rel="noopener">
						<Icon name="phone" size={16} />
						Ver demo por WhatsApp
					</a>
				</div>
				<div class="trust-row">
					<span><Icon name="check" size={14} /> Sin tarjeta</span>
					<span><Icon name="check" size={14} /> 14 días gratis</span>
					<span><Icon name="check" size={14} /> Setup en minutos</span>
				</div>
			</div>

			<!-- Animated chat mockup -->
			<div class="hero-visual">
				<div class="phone-mock">
					<div class="phone-bezel"></div>
					<div class="phone-screen">
						<div class="phone-head">
							<div class="ph-avatar">M</div>
							<div>
								<div class="ph-name">Mangu Soporte</div>
								<div class="ph-status"><span class="status-dot"></span> en línea</div>
							</div>
						</div>
						<div class="phone-msgs">
							<div class="msg-anim msg-in" style="animation-delay:.2s">
								<div class="bubble">¡Hola! Me interesa un tour por Manuel Antonio 🌴</div>
								<div class="msg-time">9:41</div>
							</div>
							<div class="msg-anim msg-out" style="animation-delay:.8s">
								<div class="ai-tag">
									<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3 7h7l-5.5 4 2 7L12 16l-6.5 4 2-7L2 9h7z"/></svg>
									AI Agent
								</div>
								<div class="bubble">¡Pura vida! Tenemos tour completo o express. ¿Para cuántas personas y qué fecha?</div>
								<div class="msg-time">9:41</div>
							</div>
							<div class="msg-anim msg-in" style="animation-delay:1.6s">
								<div class="bubble">Somos 4, el sábado 12</div>
								<div class="msg-time">9:42</div>
							</div>
							<div class="msg-anim msg-out" style="animation-delay:2.4s">
								<div class="ai-tag">
									<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3 7h7l-5.5 4 2 7L12 16l-6.5 4 2-7L2 9h7z"/></svg>
									AI Agent · creando lead
								</div>
								<div class="bubble">Listo. Disponibilidad confirmada para 4 pax el 12. Te paso a Andrés para cerrar el detalle 👋</div>
								<div class="msg-time">9:42</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Floating cards -->
				<div class="float-card lead-created">
					<div class="fc-icon" style="background:#dcfce7;color:#16a34a">
						<Icon name="kanban" size={14} />
					</div>
					<div>
						<div class="fc-title">Lead creado</div>
						<div class="fc-sub">Tour Manuel Antonio · ₡180.000</div>
					</div>
				</div>
				<div class="float-card response-time">
					<div class="fc-icon" style="background:#fef3c7;color:#b45309">
						<Icon name="trending-up" size={14} />
					</div>
					<div>
						<div class="fc-title">23s respuesta</div>
						<div class="fc-sub">↓ 92% vs antes</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Wave divider -->
		<svg class="wave" viewBox="0 0 1440 60" preserveAspectRatio="none" aria-hidden="true">
			<path d="M0,32 C240,60 480,0 720,16 C960,32 1200,56 1440,28 L1440,60 L0,60 Z" fill="var(--surface-1)"/>
		</svg>
	</section>

	<!-- ====================== Trust bar ====================== -->
	<section class="trust">
		<div class="container">
			<p class="trust-title">Más de 200 negocios costarricenses ya atienden con Mangu</p>
			<div class="logo-row">
				{#each ['Tropical Tours', 'Soda Tica', 'Casa Verde', 'Pura Tech', 'Costa Cars', 'Café Sabanilla'] as logo}
					<div class="logo-mark">{logo}</div>
				{/each}
			</div>
		</div>
	</section>

	<!-- ====================== Problem / Solution ====================== -->
	<section class="problem">
		<div class="container">
			<div class="section-head">
				<div class="eyebrow">El problema</div>
				<h2>Tus clientes ya están en WhatsApp.<br/>Tu negocio probablemente no.</h2>
			</div>
			<div class="vs-grid">
				<div class="vs-card before">
					<div class="vs-tag">❌ Sin Mangu</div>
					<ul>
						<li>3 horas para responder un mensaje</li>
						<li>Leads se pierden en chats sin orden</li>
						<li>Tu vendedor estrella contesta de noche</li>
						<li>No sabes qué canal vende mejor</li>
						<li>Cada agente trabaja en su WhatsApp personal</li>
					</ul>
				</div>
				<div class="vs-arrow">
					<Icon name="arrow-right" size={28} />
				</div>
				<div class="vs-card after">
					<div class="vs-tag">✅ Con Mangu</div>
					<ul>
						<li><b>Menos de 30s</b> de respuesta automática</li>
						<li>Pipeline visual: cada lead en su etapa</li>
						<li>AI Agent atiende 24/7 sin pagar horas extra</li>
						<li>Métricas claras por canal y por agente</li>
						<li>Una sola bandeja para todo el equipo</li>
					</ul>
				</div>
			</div>
		</div>
	</section>

	<!-- ====================== Features ====================== -->
	<section id="features" class="features">
		<div class="container">
			<div class="section-head">
				<div class="eyebrow">Funciones</div>
				<h2>Todo lo que necesitas. Nada que sobre.</h2>
				<p class="section-sub">Las herramientas que un negocio en CR realmente usa, sin la sobrecarga de los CRMs gringos.</p>
			</div>
			<div class="feat-grid">
				{#each FEATURES as f}
					<article class="feat">
						<div class="feat-icon" style="background:{f.color}1a;color:{f.color}">
							<Icon name={f.icon} size={20} />
						</div>
						<h3>{f.title}</h3>
						<p>{f.desc}</p>
					</article>
				{/each}
			</div>
		</div>
	</section>

	<!-- ====================== Bento product showcase ====================== -->
	<section class="bento">
		<div class="container">
			<div class="section-head">
				<div class="eyebrow">El producto</div>
				<h2>Diseñado para que vendas, no para configurar.</h2>
			</div>
			<div class="bento-grid">
				<!-- AI Agent card (large) -->
				<div class="bento-cell large gradient-green">
					<div class="bento-text">
						<div class="micro-badge">AI Agent</div>
						<h3>Tu vendedor digital habla como tu mejor empleado.</h3>
						<p>Eliges una plantilla, le das tono tico y conoce tu negocio. Llama herramientas reales: crea leads, agenda llamadas, escala al humano.</p>
					</div>
					<!-- Mini chat preview -->
					<div class="mini-chat">
						<div class="mc-msg in">¿Tienen entrega a Cartago?</div>
						<div class="mc-msg out"><span class="mc-tag">AI</span> Sí, cubrimos Cartago centro y Tres Ríos. ¿Te paso opciones?</div>
						<div class="mc-tools">
							<span class="mc-chip">✓ kb_search</span>
							<span class="mc-chip">✓ qualify_lead</span>
						</div>
					</div>
				</div>

				<!-- Pipeline mini -->
				<div class="bento-cell gradient-blue">
					<div class="bento-text">
						<div class="micro-badge">CRM</div>
						<h3>Pipeline kanban con drag & drop.</h3>
						<p>Mueve leads, marca ganados, ve el valor del embudo en tiempo real.</p>
					</div>
					<div class="kanban-mini">
						<div class="km-col"><div class="km-title">Nuevo</div><div class="km-card">Tour 4 pax</div></div>
						<div class="km-col"><div class="km-title">Calificado</div><div class="km-card">Reserva hotel</div></div>
						<div class="km-col"><div class="km-title">Ganado</div><div class="km-card">Tour Arenal · ₡240k</div></div>
					</div>
				</div>

				<!-- Inbox mini -->
				<div class="bento-cell">
					<div class="bento-text">
						<div class="micro-badge">Bandeja</div>
						<h3>Una sola bandeja para todo.</h3>
						<p>WhatsApp, web, email y más. Asignación automática y transferencias entre agentes.</p>
					</div>
					<div class="inbox-mini">
						<div class="im-row unread"><div class="im-avatar">A</div><div class="im-text"><b>Andrea Solano</b><span>Hola, me interesa...</span></div><span class="ch wa">WA</span></div>
						<div class="im-row"><div class="im-avatar">L</div><div class="im-text"><b>Luis Mora</b><span>Gracias por la info</span></div><span class="ch web">WEB</span></div>
						<div class="im-row"><div class="im-avatar">S</div><div class="im-text"><b>Sofía R.</b><span>¿Tienen disponibilidad?</span></div><span class="ch wa">WA</span></div>
					</div>
				</div>

				<!-- Stats mini -->
				<div class="bento-cell wide gradient-coral">
					<div class="bento-text">
						<div class="micro-badge">Analítica</div>
						<h3>Métricas que de verdad importan.</h3>
						<p>Tiempo de respuesta, conversión, embudo, satisfacción del agente IA. Todo en un dashboard.</p>
					</div>
					<div class="chart-mini">
						<svg viewBox="0 0 240 80" class="chart-svg">
							<polyline points="0,60 30,55 60,40 90,45 120,30 150,25 180,15 210,20 240,10"
								fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
							<polyline points="0,70 30,65 60,55 90,50 120,45 150,38 180,32 210,28 240,22"
								fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="2" stroke-dasharray="4 3"/>
						</svg>
					</div>
				</div>
			</div>
		</div>
	</section>

	<!-- ====================== Industries (CR-focused) ====================== -->
	<section id="industries" class="industries">
		<div class="container">
			<div class="section-head">
				<div class="eyebrow">Industrias</div>
				<h2>Hecho para tu negocio en Costa Rica</h2>
				<p class="section-sub">Plantillas listas, integración con WhatsApp Business y atención bilingüe ES/EN para los rubros que mueven el país.</p>
			</div>
			<div class="ind-grid">
				{#each INDUSTRIES as ind}
					<article class="ind-card">
						<div class="ind-img" style="background-image:url({ind.img})">
							<span class="ind-emoji">{ind.icon}</span>
						</div>
						<div class="ind-body">
							<h3>{ind.title}</h3>
							<p>{ind.desc}</p>
						</div>
					</article>
				{/each}
			</div>
		</div>
	</section>

	<!-- ====================== How it works ====================== -->
	<section id="how" class="how">
		<div class="container">
			<div class="section-head">
				<div class="eyebrow">Cómo funciona</div>
				<h2>De cero a vendiendo en 15 minutos</h2>
			</div>
			<div class="steps-grid">
				{#each STEPS as s, i}
					<div class="step">
						<div class="step-num">{s.n}</div>
						<h3>{s.title}</h3>
						<p>{s.desc}</p>
						{#if i < STEPS.length - 1}
							<div class="step-arrow"><Icon name="arrow-right" size={16} /></div>
						{/if}
					</div>
				{/each}
			</div>
		</div>
	</section>

	<!-- ====================== Stats ====================== -->
	<section class="stats">
		<div class="container">
			<div class="stats-grid">
				{#each STATS as s}
					<div class="stat">
						<div class="stat-value">{s.value}</div>
						<div class="stat-label">{s.label}</div>
					</div>
				{/each}
			</div>
		</div>
	</section>

	<!-- ====================== Testimonials ====================== -->
	<section class="testi">
		<div class="container">
			<div class="section-head">
				<div class="eyebrow">Casos reales</div>
				<h2>Negocios ticos que ya cierran más con menos esfuerzo</h2>
			</div>
			<div class="testi-grid">
				{#each TESTIMONIALS as t}
					<article class="testi-card">
						<div class="quote-mark">"</div>
						<p class="quote">{t.quote}</p>
						<div class="testi-foot">
							<img src={t.avatar} alt={t.name} loading="lazy" referrerpolicy="no-referrer" />
							<div>
								<div class="testi-name">{t.name}</div>
								<div class="testi-role">{t.role}</div>
							</div>
							<div class="stars">⭐⭐⭐⭐⭐</div>
						</div>
					</article>
				{/each}
			</div>
		</div>
	</section>

	<!-- ====================== Pricing ====================== -->
	<section id="pricing" class="pricing">
		<div class="container">
			<div class="section-head">
				<div class="eyebrow">Precios</div>
				<h2>Empieza gratis. Crece a tu ritmo.</h2>
				<p class="section-sub">Precios en colones 🇨🇷 (equivalente en USD a TC ₡460). Paga por SINPE Móvil. Sin contratos largos.</p>
			</div>
			<div class="plans-grid">
				{#each PLANS as p}
					<div class="plan" class:highlighted={p.highlighted}>
						{#if p.highlighted}<div class="badge-pop">Más popular</div>{/if}
						<h3>{p.name}</h3>
						<div class="price">
							{#if p.priceUsd}
								<span class="price-amt">{p.priceCrc}</span>
								<span class="price-period">{p.period}</span>
								<div class="price-crc">≈ {p.priceUsd} USD{p.period}</div>
							{:else}
								<span class="price-amt-text">{p.priceCrc}</span>
							{/if}
						</div>
						<ul class="plan-bullets">
							{#each p.bullets as b}
								<li><Icon name="check" size={14} /> {b}</li>
							{/each}
						</ul>
						<button
							class="btn btn-block"
							class:btn-primary={p.highlighted}
							class:btn-secondary={!p.highlighted}
							onclick={onGoToLogin}
						>{p.cta}</button>
					</div>
				{/each}
			</div>
		</div>
	</section>

	<!-- ====================== CTA ====================== -->
	<section class="cta">
		<div class="container">
			<div class="cta-card">
				<div class="cta-bg">
					<div class="cta-blob b1"></div>
					<div class="cta-blob b2"></div>
				</div>
				<div class="cta-content">
					<div class="cta-flag">🇨🇷</div>
					<h2>Lleva tu atención al siguiente nivel.<br/>Pura vida desde el día uno.</h2>
					<p>Activa tu cuenta gratis y ve los primeros leads calificados por IA esta misma tarde.</p>
					<div class="cta-actions">
						<button class="btn btn-primary btn-lg" onclick={onGoToLogin}>
							Empezar ahora
							<Icon name="arrow-right" size={16} />
						</button>
						<a class="btn btn-secondary-on-dark btn-lg" href="https://wa.me/50686789960" target="_blank" rel="noopener">
							<Icon name="phone" size={16} />
							+506 8678-9960
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>

	<!-- ====================== Footer ====================== -->
	<footer class="footer">
		<div class="container foot-grid">
			<div class="foot-col foot-brand">
				<div class="brand">
					<div class="brand-mark">M</div>
					<span class="brand-name">Mangu</span>
				</div>
				<p class="foot-desc">CRM con AI Agents, hecho desde Costa Rica para Latinoamérica.</p>
				<div class="foot-social">
					<a href="https://wa.me/50686789960" target="_blank" rel="noopener" aria-label="WhatsApp">
						<Icon name="phone" size={16} />
					</a>
					<a href="mailto:hola@manguchat.com" aria-label="Email">
						<Icon name="mail" size={16} />
					</a>
				</div>
			</div>
			<div class="foot-col">
				<h4>Producto</h4>
				<a href="#features">Funciones</a>
				<a href="#pricing">Precios</a>
				<a href="#how">Cómo funciona</a>
				<a href="#industries">Industrias</a>
			</div>
			<div class="foot-col">
				<h4>Empresa</h4>
				<a href="#">Sobre Mangu</a>
				<a href="#">Contacto</a>
				<a href="#">Soporte</a>
			</div>
			<div class="foot-col">
				<h4>Legal</h4>
				<a href="#">Términos</a>
				<a href="#">Privacidad</a>
				<a href="#">Procesamiento de datos</a>
			</div>
		</div>
		<div class="foot-bottom container">
			<span>© 2026 Mangu — Hecho con 🇨🇷 en Costa Rica</span>
			<span class="foot-credits">
				Diseño y desarrollo:
				<a href="https://costaricawebdesigners.com" target="_blank" rel="noopener">Costa Rica Web Designers</a>
			</span>
		</div>
	</footer>
</div>

<style>
	.lp { background: var(--surface-0); color: var(--text-1); overflow-x: hidden; }
	.container { max-width: 1180px; margin: 0 auto; padding: 0 24px; }
	.section-head { text-align: center; max-width: 720px; margin: 0 auto 56px; }
	.eyebrow {
		display: inline-block;
		font-size: 11px;
		letter-spacing: 0.12em;
		text-transform: uppercase;
		font-weight: 700;
		color: var(--brand-dark);
		background: var(--brand-soft);
		padding: 4px 10px;
		border-radius: 9999px;
		margin-bottom: 14px;
	}
	.section-head h2 {
		font-size: 36px;
		letter-spacing: -0.025em;
		line-height: 1.15;
		margin-bottom: 14px;
	}
	.section-sub { color: var(--text-2); font-size: 16px; line-height: 1.55; }

	/* ===== Header ===== */
	.lp-head {
		position: sticky; top: 0; z-index: 60;
		background: rgba(255, 255, 255, 0.85);
		backdrop-filter: blur(14px);
		-webkit-backdrop-filter: blur(14px);
		border-bottom: 1px solid var(--border-1);
	}
	.nav { height: 68px; display: flex; align-items: center; gap: 28px; }
	.brand { display: flex; align-items: center; gap: 10px; }
	.brand-mark {
		width: 34px; height: 34px;
		border-radius: 9px;
		background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
		display: flex; align-items: center; justify-content: center;
		font-weight: 800; color: #fff;
	}
	.brand-name { font-weight: 700; font-size: 18px; letter-spacing: -0.015em; }
	.cr-flag { font-size: 16px; }
	.links { margin-left: auto; display: flex; gap: 28px; }
	.links a { font-size: 14px; color: var(--text-2); font-weight: 500; }
	.links a:hover { color: var(--text-1); }
	.actions { display: flex; gap: 8px; }

	/* ===== Hero ===== */
	.hero {
		padding: 80px 0 120px;
		position: relative;
		background:
			radial-gradient(ellipse at 15% 0%, rgba(37, 211, 102, 0.16), transparent 55%),
			radial-gradient(ellipse at 85% 30%, rgba(255, 107, 53, 0.10), transparent 55%),
			radial-gradient(ellipse at 50% 100%, rgba(79, 109, 245, 0.08), transparent 60%),
			var(--surface-0);
	}
	.wave { position: absolute; bottom: -1px; left: 0; width: 100%; height: 60px; }
	.hero-grid {
		display: grid;
		grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
		gap: 48px;
		align-items: center;
		position: relative;
	}
	.hero-text { opacity: 0; transform: translateY(20px); transition: all 800ms cubic-bezier(0.4,0,0.2,1); }
	.lp.mounted .hero-text { opacity: 1; transform: translateY(0); }
	.badge-pill {
		display: inline-flex; align-items: center; gap: 8px;
		font-size: 12px; font-weight: 600;
		padding: 6px 14px;
		background: rgba(37, 211, 102, 0.1);
		border: 1px solid rgba(37, 211, 102, 0.25);
		color: var(--brand-dark);
		border-radius: 9999px;
		margin-bottom: 22px;
	}
	.dot.pulse {
		width: 8px; height: 8px;
		border-radius: 50%;
		background: var(--brand);
		box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.6);
		animation: pulse 1.8s infinite;
	}
	@keyframes pulse {
		0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.6); }
		70% { box-shadow: 0 0 0 14px rgba(37, 211, 102, 0); }
		100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
	}

	.hero h1 {
		font-size: clamp(36px, 5.2vw, 60px);
		line-height: 1.05;
		letter-spacing: -0.03em;
		font-weight: 800;
		margin-bottom: 22px;
	}
	.hl {
		background: linear-gradient(135deg, var(--brand) 0%, #ff9b3d 100%);
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
	}
	.lead {
		font-size: 18px; line-height: 1.6;
		color: var(--text-2);
		margin-bottom: 32px;
		max-width: 540px;
	}
	.cta-row { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 24px; }
	.trust-row { display: flex; gap: 22px; flex-wrap: wrap; font-size: 13px; color: var(--text-3); }
	.trust-row span { display: inline-flex; align-items: center; gap: 6px; }
	.trust-row :global(svg) { color: var(--brand); }

	/* Phone mockup */
	.hero-visual {
		position: relative;
		display: flex; align-items: center; justify-content: center;
		min-height: 540px;
		opacity: 0; transform: translateY(20px) scale(0.96);
		transition: all 900ms cubic-bezier(0.4,0,0.2,1) 200ms;
	}
	.lp.mounted .hero-visual { opacity: 1; transform: translateY(0) scale(1); }
	.phone-mock {
		position: relative;
		width: 320px; height: 600px;
		border-radius: 38px;
		background: #1a1f2e;
		padding: 14px;
		box-shadow:
			0 30px 80px rgba(15, 23, 42, 0.25),
			0 0 0 8px rgba(15, 23, 42, 0.06),
			inset 0 0 0 2px rgba(255, 255, 255, 0.04);
	}
	.phone-bezel {
		position: absolute;
		top: 18px; left: 50%; transform: translateX(-50%);
		width: 110px; height: 22px;
		background: #0f172a;
		border-radius: 11px;
		z-index: 1;
	}
	.phone-screen {
		width: 100%; height: 100%;
		background: linear-gradient(180deg, #f7f8fa 0%, #ffffff 100%);
		border-radius: 26px;
		overflow: hidden;
		display: flex; flex-direction: column;
		padding-top: 50px;
	}
	.phone-head {
		padding: 12px 16px;
		display: flex; align-items: center; gap: 10px;
		border-bottom: 1px solid #eef0f4;
	}
	.ph-avatar {
		width: 36px; height: 36px;
		border-radius: 50%;
		background: linear-gradient(135deg, var(--brand), var(--brand-dark));
		color: #fff;
		display: flex; align-items: center; justify-content: center;
		font-weight: 700;
	}
	.ph-name { font-size: 13.5px; font-weight: 600; color: #1a1f2e; }
	.ph-status {
		font-size: 11px; color: #4ade80;
		display: flex; align-items: center; gap: 4px;
	}
	.status-dot {
		width: 7px; height: 7px;
		border-radius: 50%;
		background: #4ade80;
	}
	.phone-msgs {
		flex: 1;
		padding: 14px;
		overflow: hidden;
		display: flex; flex-direction: column;
		gap: 12px;
	}
	.msg-anim {
		opacity: 0;
		transform: translateY(8px);
		animation: msg-in 600ms cubic-bezier(0.4,0,0.2,1) forwards;
		max-width: 75%;
		display: flex; flex-direction: column;
		gap: 2px;
	}
	@keyframes msg-in {
		to { opacity: 1; transform: translateY(0); }
	}
	.msg-anim.msg-in { align-self: flex-start; }
	.msg-anim.msg-out { align-self: flex-end; align-items: flex-end; }
	.msg-anim .bubble {
		padding: 8px 12px;
		border-radius: 14px;
		font-size: 13px;
		line-height: 1.4;
	}
	.msg-anim.msg-in .bubble {
		background: #fff;
		border: 1px solid #eef0f4;
		color: #1a1f2e;
		border-bottom-left-radius: 4px;
	}
	.msg-anim.msg-out .bubble {
		background: linear-gradient(135deg, var(--brand), var(--brand-dark));
		color: #fff;
		border-bottom-right-radius: 4px;
	}
	.msg-time { font-size: 10px; color: #9ca3af; padding: 0 4px; }
	.ai-tag {
		display: inline-flex; align-items: center; gap: 4px;
		font-size: 10px;
		font-weight: 700;
		color: var(--brand-dark);
		margin-bottom: 2px;
	}
	.ai-tag svg { color: var(--brand-dark); }

	.float-card {
		position: absolute;
		display: flex; align-items: center; gap: 10px;
		background: #fff;
		padding: 10px 14px;
		border-radius: 12px;
		box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
		font-size: 12px;
		animation: float 4s ease-in-out infinite;
	}
	.float-card.lead-created {
		top: 80px; left: -40px;
		animation-delay: 0.5s;
	}
	.float-card.response-time {
		bottom: 100px; right: -30px;
		animation-delay: 1.5s;
	}
	@keyframes float {
		0%, 100% { transform: translateY(0); }
		50% { transform: translateY(-8px); }
	}
	.fc-icon {
		width: 30px; height: 30px;
		border-radius: 8px;
		display: flex; align-items: center; justify-content: center;
		flex-shrink: 0;
	}
	.fc-title { font-weight: 700; color: var(--text-1); }
	.fc-sub { font-size: 11px; color: var(--text-3); }

	/* ===== Trust bar ===== */
	.trust { padding: 56px 0; background: var(--surface-1); }
	.trust-title {
		text-align: center;
		font-size: 13px; font-weight: 600;
		color: var(--text-3);
		margin-bottom: 24px;
		letter-spacing: 0.02em;
	}
	.logo-row {
		display: flex; flex-wrap: wrap; gap: 28px;
		align-items: center; justify-content: center;
	}
	.logo-mark {
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		font-size: 17px;
		letter-spacing: -0.02em;
		color: var(--text-3);
		opacity: 0.7;
		padding: 4px 8px;
	}
	.logo-mark:hover { opacity: 1; color: var(--text-2); }

	/* ===== Problem / Solution ===== */
	.problem { padding: 100px 0; background: var(--surface-0); }
	.vs-grid {
		display: grid;
		grid-template-columns: 1fr auto 1fr;
		gap: 24px;
		align-items: stretch;
	}
	.vs-card {
		padding: 32px;
		border-radius: 16px;
		display: flex; flex-direction: column; gap: 12px;
	}
	.vs-card.before {
		background: var(--surface-1);
		border: 1px dashed var(--border-2);
	}
	.vs-card.after {
		background: linear-gradient(135deg, rgba(37, 211, 102, 0.06), rgba(37, 211, 102, 0.12));
		border: 1px solid rgba(37, 211, 102, 0.25);
	}
	.vs-tag {
		font-size: 13px; font-weight: 700;
		color: var(--text-2);
		margin-bottom: 6px;
	}
	.vs-card.after .vs-tag { color: var(--brand-dark); }
	.vs-card ul { list-style: none; margin: 0; padding: 0; }
	.vs-card li {
		padding: 8px 0;
		font-size: 14px; color: var(--text-2);
		line-height: 1.5;
		border-top: 1px solid rgba(0,0,0,0.04);
	}
	.vs-card li:first-child { border-top: none; }
	.vs-card.after li { color: var(--text-1); }
	.vs-arrow {
		display: flex; align-items: center; justify-content: center;
		color: var(--brand);
	}

	/* ===== Features ===== */
	.features { padding: 100px 0; background: var(--surface-1); }
	.feat-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
		gap: 16px;
	}
	.feat {
		padding: 28px;
		background: var(--surface-0);
		border-radius: 14px;
		border: 1px solid var(--border-1);
		transition: all var(--transition);
	}
	.feat:hover {
		transform: translateY(-3px);
		border-color: var(--border-2);
		box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
	}
	.feat-icon {
		width: 44px; height: 44px;
		border-radius: 11px;
		display: flex; align-items: center; justify-content: center;
		margin-bottom: 16px;
	}
	.feat h3 { font-size: 17px; margin-bottom: 8px; }
	.feat p { font-size: 14px; color: var(--text-2); line-height: 1.55; }

	/* ===== Bento ===== */
	.bento { padding: 100px 0; background: var(--surface-0); }
	.bento-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-template-rows: 380px 380px;
		gap: 18px;
	}
	.bento-cell {
		grid-column: span 1;
		padding: 28px;
		border-radius: 18px;
		background: var(--surface-1);
		border: 1px solid var(--border-1);
		display: flex; flex-direction: column;
		justify-content: space-between;
		overflow: hidden;
		position: relative;
		transition: transform var(--transition);
	}
	.bento-cell:hover { transform: translateY(-3px); }
	.bento-cell.large { grid-column: span 2; }
	.bento-cell.wide  { grid-column: span 3; }
	.bento-cell.gradient-green {
		background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
		color: #fff;
		border: none;
	}
	.bento-cell.gradient-blue {
		background: linear-gradient(135deg, #4f6df5 0%, #3d5be0 100%);
		color: #fff;
		border: none;
	}
	.bento-cell.gradient-coral {
		background: linear-gradient(135deg, #FF8C42 0%, #ff5e3a 100%);
		color: #fff;
		border: none;
	}
	.micro-badge {
		display: inline-block;
		font-size: 10.5px; letter-spacing: 0.08em;
		text-transform: uppercase; font-weight: 700;
		padding: 3px 9px;
		background: rgba(255,255,255,0.18);
		color: #fff;
		border-radius: 9999px;
		margin-bottom: 12px;
	}
	.bento-cell:not([class*="gradient"]) .micro-badge {
		background: var(--accent-soft);
		color: var(--accent);
	}
	.bento-cell h3 {
		font-size: 22px;
		letter-spacing: -0.02em;
		line-height: 1.2;
		margin-bottom: 10px;
	}
	.bento-cell p { font-size: 14px; line-height: 1.55; opacity: 0.92; max-width: 480px; }
	.bento-cell:not([class*="gradient"]) p { color: var(--text-2); }

	.mini-chat {
		background: rgba(255,255,255,0.95);
		border-radius: 12px;
		padding: 14px;
		margin-top: 18px;
		display: flex; flex-direction: column; gap: 8px;
	}
	.mc-msg {
		font-size: 13px; line-height: 1.4;
		padding: 8px 12px;
		border-radius: 12px;
		max-width: 85%;
		color: #1a1f2e;
	}
	.mc-msg.in { background: #f7f8fa; align-self: flex-start; border-bottom-left-radius: 3px; }
	.mc-msg.out { background: var(--brand); color: #fff; align-self: flex-end; border-bottom-right-radius: 3px; }
	.mc-tag {
		font-size: 9.5px; font-weight: 700;
		background: rgba(0,0,0,0.15);
		padding: 1px 5px;
		border-radius: 3px;
		margin-right: 4px;
		letter-spacing: 0.05em;
	}
	.mc-tools { display: flex; gap: 6px; align-self: flex-start; padding-top: 4px; }
	.mc-chip {
		font-size: 10.5px; font-weight: 600;
		padding: 2px 7px;
		background: rgba(37, 211, 102, 0.12);
		color: var(--brand-dark);
		border-radius: 4px;
		font-family: var(--font-mono);
	}

	.kanban-mini {
		display: grid; grid-template-columns: repeat(3, 1fr);
		gap: 8px;
		margin-top: 18px;
	}
	.km-col {
		background: rgba(255,255,255,0.18);
		padding: 10px; border-radius: 8px;
	}
	.km-title {
		font-size: 10.5px; font-weight: 700;
		opacity: 0.9; margin-bottom: 6px;
		text-transform: uppercase; letter-spacing: 0.04em;
	}
	.km-card {
		background: #fff;
		color: #1a1f2e;
		padding: 8px 10px;
		border-radius: 6px;
		font-size: 12px; font-weight: 600;
		box-shadow: 0 1px 3px rgba(0,0,0,0.08);
	}

	.inbox-mini {
		display: flex; flex-direction: column;
		gap: 6px;
		margin-top: 18px;
	}
	.im-row {
		display: flex; align-items: center; gap: 10px;
		padding: 10px 12px;
		background: var(--surface-0);
		border-radius: 8px;
		border: 1px solid var(--border-1);
	}
	.im-row.unread { border-color: var(--brand); }
	.im-avatar {
		width: 30px; height: 30px;
		border-radius: 50%;
		background: linear-gradient(135deg, var(--accent), var(--accent-hover));
		color: #fff;
		display: flex; align-items: center; justify-content: center;
		font-weight: 600; font-size: 12px;
	}
	.im-text { flex: 1; min-width: 0; font-size: 12px; }
	.im-text b { display: block; color: var(--text-1); margin-bottom: 1px; }
	.im-text span { color: var(--text-3); font-size: 11.5px; }
	.ch {
		font-size: 9.5px; font-weight: 700;
		padding: 2px 6px;
		border-radius: 4px;
		letter-spacing: 0.05em;
	}
	.ch.wa { background: var(--brand-soft); color: var(--brand-dark); }
	.ch.web { background: var(--accent-soft); color: var(--accent); }

	.chart-mini { margin-top: 16px; }
	.chart-svg { width: 100%; max-height: 80px; display: block; }

	/* ===== Industries ===== */
	.industries { padding: 100px 0; background: var(--surface-1); }
	.ind-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
		gap: 20px;
	}
	.ind-card {
		background: var(--surface-0);
		border-radius: 16px;
		border: 1px solid var(--border-1);
		overflow: hidden;
		display: flex; flex-direction: column;
		transition: all var(--transition);
	}
	.ind-card:hover {
		transform: translateY(-3px);
		box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
	}
	.ind-img {
		height: 160px;
		background-size: cover;
		background-position: center;
		position: relative;
	}
	.ind-img::after {
		content: '';
		position: absolute; inset: 0;
		background: linear-gradient(180deg, transparent 50%, rgba(0,0,0,0.4));
	}
	.ind-emoji {
		position: absolute;
		bottom: 12px; left: 14px;
		font-size: 28px;
		filter: drop-shadow(0 2px 6px rgba(0,0,0,0.3));
		z-index: 1;
	}
	.ind-body { padding: 20px; }
	.ind-body h3 { font-size: 17px; margin-bottom: 8px; }
	.ind-body p { font-size: 13.5px; color: var(--text-2); line-height: 1.55; }

	/* ===== How ===== */
	.how { padding: 100px 0; background: var(--surface-0); }
	.steps-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 24px;
		position: relative;
	}
	.step {
		position: relative;
		padding: 28px;
		background: var(--surface-1);
		border-radius: 14px;
		border: 1px solid var(--border-1);
	}
	.step-num {
		font-size: 34px;
		font-weight: 800;
		background: linear-gradient(135deg, var(--brand), #ff9b3d);
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
		margin-bottom: 12px;
		letter-spacing: -0.02em;
	}
	.step h3 { font-size: 18px; margin-bottom: 8px; }
	.step p { font-size: 14px; color: var(--text-2); line-height: 1.55; }
	.step-arrow {
		position: absolute;
		right: -30px; top: 50%;
		transform: translateY(-50%);
		width: 48px; height: 48px;
		background: var(--surface-0);
		border-radius: 50%;
		display: flex; align-items: center; justify-content: center;
		color: var(--brand);
		box-shadow: var(--shadow-sm);
		z-index: 2;
	}

	/* ===== Stats ===== */
	.stats { padding: 80px 0; background: var(--surface-1); }
	.stats-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
		gap: 24px;
		text-align: center;
	}
	.stat-value {
		font-size: 44px;
		font-weight: 800;
		background: linear-gradient(135deg, var(--brand) 0%, #ff9b3d 100%);
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
		margin-bottom: 6px;
		letter-spacing: -0.025em;
	}
	.stat-label { font-size: 13.5px; color: var(--text-2); line-height: 1.45; }

	/* ===== Testimonials ===== */
	.testi { padding: 100px 0; background: var(--surface-0); }
	.testi-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
		gap: 20px;
	}
	.testi-card {
		background: var(--surface-1);
		border-radius: 16px;
		padding: 28px;
		border: 1px solid var(--border-1);
		position: relative;
	}
	.quote-mark {
		position: absolute;
		top: 14px; right: 22px;
		font-size: 64px;
		font-weight: 800;
		color: var(--brand);
		opacity: 0.18;
		line-height: 0.8;
	}
	.quote {
		font-size: 15.5px;
		line-height: 1.6;
		color: var(--text-1);
		margin-bottom: 22px;
		position: relative;
		z-index: 1;
	}
	.testi-foot {
		display: flex; align-items: center; gap: 12px;
		flex-wrap: wrap;
	}
	.testi-foot img {
		width: 44px; height: 44px;
		border-radius: 50%;
		object-fit: cover;
	}
	.testi-name { font-weight: 700; font-size: 13.5px; }
	.testi-role { font-size: 12px; color: var(--text-3); }
	.stars { font-size: 12px; margin-left: auto; letter-spacing: -2px; }

	/* ===== Pricing ===== */
	.pricing { padding: 100px 0; background: var(--surface-1); }
	.plans-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 18px;
		max-width: 1080px;
		margin: 0 auto;
	}
	.plan {
		background: var(--surface-0);
		border-radius: 18px;
		padding: 32px 26px;
		border: 1px solid var(--border-1);
		display: flex; flex-direction: column;
		gap: 18px;
		position: relative;
	}
	.plan.highlighted {
		border-color: var(--brand);
		box-shadow: 0 18px 40px rgba(37, 211, 102, 0.18);
		transform: translateY(-8px);
	}
	.badge-pop {
		position: absolute;
		top: -12px; left: 50%; transform: translateX(-50%);
		background: linear-gradient(135deg, var(--brand), var(--brand-dark));
		color: #fff;
		font-size: 11px; font-weight: 700;
		padding: 5px 14px;
		border-radius: 9999px;
		letter-spacing: 0.04em;
	}
	.plan h3 { font-size: 18px; }
	.price { line-height: 1; }
	.price-amt {
		font-size: 36px; font-weight: 800;
		letter-spacing: -0.02em;
		color: var(--text-1);
	}
	.price-amt-text { font-size: 28px; font-weight: 700; color: var(--text-1); }
	.price-period { font-size: 14px; color: var(--text-3); margin-left: 4px; }
	.price-crc { font-size: 13px; color: var(--text-3); margin-top: 6px; }
	.plan-bullets { list-style: none; padding: 0; margin: 0; flex: 1; }
	.plan-bullets li {
		display: flex; align-items: flex-start; gap: 8px;
		padding: 6px 0;
		font-size: 13.5px;
		color: var(--text-2);
	}
	.plan-bullets :global(svg) {
		color: var(--brand);
		margin-top: 3px;
		flex-shrink: 0;
	}
	.btn-block { width: 100%; justify-content: center; padding: 11px 16px; }

	/* ===== CTA ===== */
	.cta { padding: 80px 0 100px; background: var(--surface-0); }
	.cta-card {
		position: relative;
		background: linear-gradient(135deg, #1a1f2e 0%, #0f172a 100%);
		border-radius: 28px;
		padding: 72px 32px;
		text-align: center;
		color: #fff;
		overflow: hidden;
	}
	.cta-bg { position: absolute; inset: 0; pointer-events: none; }
	.cta-blob {
		position: absolute;
		width: 420px; height: 420px;
		border-radius: 50%;
		filter: blur(80px);
		opacity: 0.4;
	}
	.cta-blob.b1 { background: var(--brand); top: -80px; left: -80px; }
	.cta-blob.b2 { background: #FF6B35; bottom: -100px; right: -80px; }
	.cta-content { position: relative; z-index: 1; }
	.cta-flag { font-size: 36px; margin-bottom: 16px; }
	.cta-card h2 {
		color: #fff;
		font-size: clamp(28px, 4vw, 42px);
		letter-spacing: -0.02em;
		line-height: 1.2;
		margin-bottom: 14px;
	}
	.cta-card p {
		color: rgba(255,255,255,0.78);
		font-size: 17px;
		line-height: 1.55;
		margin-bottom: 32px;
		max-width: 540px;
		margin-left: auto;
		margin-right: auto;
	}
	.cta-actions {
		display: flex; gap: 12px; flex-wrap: wrap;
		justify-content: center;
	}
	.btn-secondary-on-dark {
		display: inline-flex; align-items: center; gap: 8px;
		background: rgba(255,255,255,0.12);
		color: #fff;
		border: 1px solid rgba(255,255,255,0.2);
		padding: 12px 20px;
		border-radius: 8px;
		font-weight: 500;
		font-size: 15px;
		text-decoration: none;
		transition: background var(--transition-fast);
	}
	.btn-secondary-on-dark:hover { background: rgba(255,255,255,0.2); }

	/* ===== Footer ===== */
	.footer { background: var(--surface-1); padding: 56px 0 28px; border-top: 1px solid var(--border-1); }
	.foot-grid {
		display: grid;
		grid-template-columns: minmax(0, 1.5fr) repeat(3, minmax(0, 1fr));
		gap: 32px;
		padding-bottom: 32px;
	}
	.foot-brand .brand { margin-bottom: 14px; }
	.foot-desc { font-size: 13.5px; color: var(--text-2); line-height: 1.55; max-width: 280px; margin-bottom: 18px; }
	.foot-social { display: flex; gap: 8px; }
	.foot-social a {
		width: 36px; height: 36px;
		border-radius: 8px;
		background: var(--surface-0);
		border: 1px solid var(--border-1);
		display: flex; align-items: center; justify-content: center;
		color: var(--text-2);
		transition: all var(--transition-fast);
	}
	.foot-social a:hover {
		background: var(--brand);
		color: #fff;
		border-color: var(--brand);
	}
	.foot-col h4 { font-size: 13px; margin-bottom: 14px; font-weight: 700; }
	.foot-col a {
		display: block;
		font-size: 13px;
		color: var(--text-2);
		padding: 5px 0;
	}
	.foot-col a:hover { color: var(--text-1); }
	.foot-bottom {
		padding-top: 24px;
		border-top: 1px solid var(--border-1);
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 8px;
		font-size: 12.5px;
		color: var(--text-3);
	}
	.foot-credits a { color: var(--text-2); font-weight: 600; }
	.foot-credits a:hover { color: var(--brand-dark); }

	/* ===== Responsive ===== */
	@media (max-width: 980px) {
		.links { display: none; }
		.hero-grid { grid-template-columns: 1fr; gap: 64px; }
		.hero-visual { min-height: 540px; }
		.float-card.lead-created { left: 10px; }
		.float-card.response-time { right: 10px; }
		.section-head h2 { font-size: 28px; }
		.vs-grid { grid-template-columns: 1fr; }
		.vs-arrow { transform: rotate(90deg); padding: 8px 0; }
		.bento-grid {
			grid-template-columns: 1fr;
			grid-template-rows: auto;
		}
		.bento-cell.large, .bento-cell.wide { grid-column: span 1; }
		.steps-grid { grid-template-columns: 1fr; gap: 16px; }
		.step-arrow { display: none; }
		.plans-grid { grid-template-columns: 1fr; max-width: 460px; }
		.plan.highlighted { transform: none; }
		.foot-grid { grid-template-columns: 1fr 1fr; }
	}
	@media (max-width: 540px) {
		.foot-grid { grid-template-columns: 1fr; }
		.hero { padding: 60px 0 100px; }
		.cta-card { padding: 48px 22px; border-radius: 20px; }
		.phone-mock { width: 280px; height: 540px; }
	}
</style>
